"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* istanbul ignore next */

/**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function ColumnGroup(_) {
  return null;
}

var _default = ColumnGroup;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-table/lib/sugar/ColumnGroup.js
// module id = 1059
// module chunks = 0